import * as TYPES from '../types';

const initialState = {
    teamList: [],
};

export function TeamReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_TEAM_MEMBERS_SUCCESS:
            return {
                ...preState,
                teamList: payload,
            };

        default:
            return state;
    }
}